import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Film, FileText, PlayCircle, ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";
import { api, resolveImageUri } from "@/lib/api";

export default function Blogs() {
  const navigate = useNavigate();
  const { data: posts = [], isLoading } = useQuery({ queryKey: ["posts"], queryFn: () => api.listPosts() });

  return (
    <div className="min-h-screen bg-paper">
      <Header />
      <main className="mx-auto max-w-4xl px-4 sm:px-6 py-10">
        <div className="flex items-center gap-2 text-brand mb-1"><Film size={18} /><span className="text-xs uppercase tracking-[0.2em] font-semibold">Read & Watch</span></div>
        <h1 className="font-display text-4xl sm:text-5xl text-ink">Blogs & Vlogs</h1>
        <p className="text-muted2 mt-2">Wellness tips, product stories and videos from Altos World.</p>

        {isLoading ? (
          <p className="text-muted2 mt-10">Loading…</p>
        ) : posts.length === 0 ? (
          <div className="text-center py-20 text-muted2" data-testid="blogs-empty"><FileText className="mx-auto text-line" size={40} /><p className="mt-3">No posts published yet.</p></div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-5 mt-8">
            {posts.map((p) => (
              <button key={p.id} onClick={() => navigate(`/blogs/${p.id}`)} data-testid={`post-${p.id}`} className="text-left rounded-2xl border border-line overflow-hidden hover:border-brand hover:shadow-sm transition-all group">
                <div className="aspect-video bg-mist relative">
                  {p.cover_image ? (
                    <img src={resolveImageUri(p.cover_image)} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-brand">
                      {p.type === "vlog" ? <PlayCircle size={40} /> : <FileText size={40} />}
                    </div>
                  )}
                  <span className="absolute top-3 left-3 text-[11px] font-semibold uppercase tracking-wide bg-paper/90 text-brand px-2 py-0.5 rounded-full">{p.type === "vlog" ? "Vlog" : "Blog"}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-display text-2xl text-ink leading-tight group-hover:text-brand transition-colors line-clamp-2">{p.title}</h3>
                  <p className="text-xs text-muted2 mt-1">{(p.created_at || "").slice(0, 10)}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-brand mt-2">{p.type === "vlog" ? "Watch" : "Read"} <ChevronRight size={15} /></span>
                </div>
              </button>
            ))}
          </div>
        )}
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
